interface IconOnlyButtonProps {
  icon: React.JSX.Element;
}

const IconOnlyButton = ({ icon }: IconOnlyButtonProps) => {
  return icon;
};

export default IconOnlyButton;
